import { tv } from "tailwind-variants";
const autocompleteVariants = tv({
    slots: {
        listWrapperSlot: 'z-100 bg-neutral-1 absolute top-[52px] flex h-[300px] w-full flex-col rounded-xl',
        overlayInputSlot: 'relative mt-1 grid w-full grid-cols-[48px_1fr] gap-3 px-3'
    },
    variants: {
        isHidden: {
            true: {
                listWrapperSlot: 'hidden'
            }
        }
    }
});
export { autocompleteVariants };
